import React from "react";
import Layout from "../Layout";
import Form from "./form";
import useApi from "Hooks/Admin/useApi";
import useAuth from "Hooks/Admin/useAuth";
import useError from "Hooks/useError";
import { message } from "constants/message";
import { withRouter } from "react-router";
import dayjs from "dayjs";
dayjs.locale("ja");

function Dtm(props) {
  const { params } = props.match;
  const dtmId = parseInt(params.id, 10);

  const { request } = useApi();
  const auth = useAuth();
  const stateError = useError();
  const messages = message();
  const [dtm, setDtm] = React.useState(null);

  React.useEffect(() => {
    // タイトル変更
    document.title = "Buzz Finder Admin - DTM告知編集";
  }, []);

  React.useEffect(() => {
    if (!auth.state.token) {
      return;
    }
    fetchDtm();
  }, [auth.state.token]);

  const fetchDtm = () => {
    request({
      method: "GET",
      url: `admin/dtm_notices/${dtmId}`,
    }).then((result) => {
      const data = {
        validFrom: result.data.data.valid_from,
        validUntil: result.data.data.valid_until,
        label: result.data.data.label,
        desc: result.data.data.desc,
        message: result.data.data.message,
      }

      setDtm(data);
    });
  }

  const handleSubmit = (dtm) => {
    request({
      method: "PUT",
      url: `admin/dtm_notices/${dtmId}`,
      data: {
        valid_from: dtm.validFrom,
        valid_until: dtm.validUntil,
        label: dtm.label,
        desc: dtm.desc,
        message: dtm.dtmMessage,
      },
    })
      .then((data) => {
        stateError.initialize();
        props.history.push("/admin/dtm?success=edit");
      })
      .catch((error) => {
        stateError.dispatch({
          type: "set",
          payload: {
            isError: true,
            errorMsg: messages.validation.common,
          },
        });
      });
  };

  return (
    <Layout
      content={
        <Form
          submit={handleSubmit}
          dtm={dtm}
          isEdit={true}
        />
      }
    />
  );
}
export default withRouter(Dtm);
